import PrivacyPolicy from "pages/PrivacyPolicy";
import Submit from "pages/Submit";
import Test from "pages/Test";
import ThankyouFlow1 from "pages/ThankyouFlow1";
import ThankyouFlow2 from "pages/ThankyouFlow2";
import Voucher from "pages/Voucher";
import React, {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

const appRouter = (props) => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Submit />} />
        <Route path="/submit" element={<Submit />} />
        <Route path="/thankyou-flow1" element={<ThankyouFlow1 />} />
        <Route path="/thankyou-flow2" element={<ThankyouFlow2 />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/rewards" element={<Voucher />} />
      </Routes>
    </Router>
  );
};

export default appRouter;
